import React from 'react';
import { WebsiteDesignProps } from './types';
import { Clover, Castle, Shield } from 'lucide-react';
import { Button } from "@/components/ui/button";

const StoneIvy: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Cathedral College";

    return (
        <div className="bg-[#1c1c1c] text-[#a8a8a8] min-h-screen font-serif">
            {/* Stone Texture */}
            <div className="fixed inset-0 pointer-events-none opacity-20" style={{backgroundImage: `url("https://www.transparenttextures.com/patterns/dark-matter.png")`}}></div>

            <nav className="relative z-10 border-b border-[#333] p-8 flex justify-center bg-[#111]">
                <div className="flex flex-col items-center gap-2">
                    <Castle size={40} className="text-[#a8a8a8]" />
                    <h1 className="text-2xl font-bold uppercase tracking-[0.3em] text-[#d4d4d4]">{schoolName}</h1>
                </div>
            </nav>

            <main className="container mx-auto px-6 py-20 relative z-10">
                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                     <div>
                         <h2 className="text-5xl md:text-7xl font-bold text-[#e5e5e5] mb-8 leading-tight">
                             Tradition <br/> & Eternity.
                         </h2>
                         <div className="h-[2px] w-24 bg-[#4a4a4a] mb-8"></div>
                         <p className="text-lg text-[#888] leading-relaxed mb-12 max-w-md">
                             Within these ancient stone walls, we cultivate the minds that will shape the future. A legacy of excellence since 1450.
                         </p>
                         <Button variant="outline" className="border-[#666] text-[#ccc] hover:bg-[#333] hover:text-white uppercase tracking-widest px-8 py-6 rounded-none">
                             View Prospectus
                         </Button>
                     </div>

                     <div className="relative">
                         {/* Arch Shape */}
                         <div className="w-full h-[500px] rounded-t-[250px] overflow-hidden border-4 border-[#333] relative">
                             <img src="https://images.unsplash.com/photo-1590634351368-2e0a2955f656?q=80&w=2000&auto=format&fit=crop" className="w-full h-full object-cover filter grayscale contrast-125 hover:scale-105 transition-transform duration-1000" alt="Gothic Architecture" />
                             <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-80"></div>
                         </div>
                         
                         {/* Ivy Decoration */}
                         <Clover className="absolute -bottom-4 -right-4 text-green-800/50 w-24 h-24" strokeWidth={1} />
                         <Clover className="absolute -bottom-12 -right-0 text-green-800/50 w-16 h-16" strokeWidth={1} />
                     </div>
                 </div>

                 <div className="mt-24 border-t border-[#333] pt-12 text-center">
                     <div className="inline-flex gap-16 text-[#666] uppercase tracking-widest text-sm font-bold">
                         <div className="flex items-center gap-2"><Shield size={16} /> Honor</div>
                         <div className="flex items-center gap-2"><Castle size={16} /> Strength</div>
                         <div className="flex items-center gap-2"><Clover size={16} /> Growth</div>
                     </div>
                 </div>
            </main>
        </div>
    );
};

export default StoneIvy;
